/**
 * Ticks the same-day-cutoff countdown rendered by component-order-by.liquid.
 * All copy is server-rendered and already translated — this only ever
 * updates the numeric countdown, and swaps in the (also server-rendered,
 * translated) "ships tomorrow" markup once the cutoff passes.
 */
if (!customElements.get('order-by-message')) {
  customElements.define(
    'order-by-message',
    class OrderByMessage extends HTMLElement {
      connectedCallback() {
        const remaining = Number(this.dataset.remaining);
        if (!remaining) return;

        this.deadline = Date.now() + remaining * 1000;
        this.textEl = this.querySelector('[data-order-by-text]');
        this.countdownEl = this.querySelector('[data-order-by-countdown]');

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const secondsLeft = Math.round((this.deadline - Date.now()) / 1000);

        if (secondsLeft <= 0) {
          clearInterval(this.timer);
          // Theme-authored, already-translated markup — same trust level as
          // the rest of this element's server-rendered content.
          if (this.textEl && this.dataset.shipsTomorrowHtml) {
            this.textEl.innerHTML = this.dataset.shipsTomorrowHtml;
          }
          return;
        }

        if (this.countdownEl) this.countdownEl.textContent = OrderByMessage.formatDuration(secondsLeft);
      }

      static formatDuration(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds / 60) % 60);
        const seconds = Math.floor(totalSeconds % 60);
        return `${hours}h ${minutes}m ${seconds}s`;
      }
    },
  );
}
